export default __webpack_public_path__ + "static/media/whychooseicon2.2dd14f46.png";